<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createUser" (change)="registrationChange()" (submit)="registrationSubmit()">
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->
                    <!-- <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">

                    </div> -->
                    <div class="col-md-10 mx-md-auto py-3">

                        <div class="row">
                            <div class="col-md-12 px-md-5 mb-4">
                                <div class="col-md-12 d-flex align-self-center justify-content-center">
                                    <h6 class="font-bold m-0">SEC - Registration</h6>
                                </div>
                                <div class="col-md-12 d-flex flex-wrap justify-content-center">
                                    <button type="reset" class="btn btn-outline-secondary m-2 rounded-0"
                                        *ngIf="!creating">
                                        {{ "RESET" | translate | titlecase }}</button>
                                    <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                                            class="fas fa-user-plus"></i>
                                        {{ "SAVE" | translate | titlecase }}</button>
                                    <div class="dropdown">
                                        <button class="btn btn-link dropdown-toggle" type="button"
                                            id="dropdownLangButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i class="fas fa-globe"></i> {{ currentLang }}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownLangButton">
                                            <a class="dropdown-item" (click)="changeLang('en')">{{ "EN" | translate |
                                                titlecase }}</a>
                                            <a class="dropdown-item" (click)="changeLang('ar')">{{ "AR" | translate |
                                                titlecase }}</a>
                                        </div>
                                    </div>
                                    <app-loader [show]="creating"></app-loader>
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">User Status</label>
                                <select class="form-control custom-select" readonly disabled>
                                    <option value="">Select</option>
                                    <option value="Activated" selected>Activated</option>
                                </select>
                            </div> -->
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FIRST_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEnglish1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameEnglish1.touched && createUser.controls.nameEnglish1.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SECOND_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEnglish2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameEnglish2.touched && createUser.controls.nameEnglish2.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THIRD_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEnglish3">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameEnglish3.touched && createUser.controls.nameEnglish3.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FOURTH_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEnglish4">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameEnglish4.touched && createUser.controls.nameEnglish4.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>



                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FIRST_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameArabic1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameArabic1.touched && createUser.controls.nameArabic1.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SECOND_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameArabic2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameArabic2.touched && createUser.controls.nameArabic2.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THIRD_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameArabic3">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameArabic3.touched && createUser.controls.nameArabic3.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FOURTH_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameArabic4">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameArabic4.touched && createUser.controls.nameArabic4.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEnglish3">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nameEnglish3.touched && createUser.controls.nameEnglish3.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div> -->
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="fullNameArabic">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.fullNameArabic.touched && createUser.controls.fullNameArabic.invalid && createUser.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "NATIONAL_ID" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nationalID">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nationalID.touched && createUser.controls.nationalID.invalid && createUser.dirty">
                                    {{ "PLEASE_ENTER_VALID_NATIONAL_ID" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THANAWYA_SCORE" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="bachelorScore"
                                    (change)="getPrecentage()">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorScore.touched && createUser.controls.bachelorScore.invalid && createUser.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorScore?.errors?.min && createUser.controls.bachelorScore.invalid">
                                    {{ "MIN_VALUE_IS" | translate | titlecase }} {{ this.thanawyaGradeMin }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorScore?.errors?.max && createUser.controls.bachelorScore.invalid">
                                    {{ "MAX_VALUE_IS" | translate | titlecase }} {{ this.thanawyaGradeMax }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THANAWYA" | translate | titlecase }} %</label>
                                <input type="text" class="form-control" formControlName="bachelorPercentage" readonly>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorPercentage.touched && createUser.controls.bachelorPercentage.invalid && createUser.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorPercentage?.errors?.min && createUser.controls.bachelorPercentage.invalid">
                                    {{ "MIN_VALUE_IS" | translate | titlecase }} {{ this.thanawyaPrecentage }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorPercentage?.errors?.max && createUser.controls.bachelorPercentage.invalid">
                                    {{ "MAX_VALUE_IS" | translate | titlecase }} 100
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THANAWYA_CERT" | translate | titlecase }}</label>
                                <input type="file" class="form-control" formControlName="bachelorCert"
                                    accept=".png, .jpg, .jpeg" (change)="changeCertFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorCert.touched && createUser.controls.bachelorCert.invalid && createUser.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THANAWYA_CARD" | translate | titlecase }} (بطاقة
                                    الترشيح)</label>
                                <input type="file" class="form-control" formControlName="bachelorCard"
                                    accept=".png, .jpg, .jpeg" (change)="changeCardFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.bachelorCard.touched && createUser.controls.bachelorCard.invalid && createUser.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "NATIONAL_ID_FIle" | translate | titlecase }}</label>
                                <input type="file" class="form-control" formControlName="nIDFile"
                                    accept=".png, .jpg, .jpeg " (change)="changeNIDFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.nIDFile.touched && createUser.controls.nIDFile.invalid && createUser.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMAIL" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="email">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.email.touched && createUser.controls.email.invalid && createUser.dirty">
                                    {{ "PLEASE_ENTER_VALID_MAIL" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>